import _ from 'lodash';
import { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';



type DataPoint = {
  x: string;
  y: string;
  value: string;
};

export type SimpleDataTableProps = {
  domain: string[];
  range: string[];

  data: DataPoint[];

  emptyCasePlaceholder?: string;
};

export const FC = ({
  domain, range, data, emptyCasePlaceholder
}: SimpleDataTableProps) => {

  const accessOptimizedData = useMemo(() => {
    const grouped = _.groupBy(data, (d) => d.x);
    return _.mapValues(grouped, (group) => _.keyBy(group, (i) => i.y));
  }, [data]);

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            {/* For The range column */}
            <TableCell />

            {domain.map((item) => (
              <TableCell key={item}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {range.map((y) => (
            <TableRow key={y}>
              <TableCell>
                {y}
              </TableCell>

              {domain.map((x) => (
                <TableCell key={`${y}-${x}`}>
                  {accessOptimizedData[x]?.[y]?.value ?? emptyCasePlaceholder}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
